import LocationSchedule from './LocationSchedule.view';

export default LocationSchedule;
